"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getAggregationQueryForGroup = void 0;
const getShouldQueryForGroup_1 = require("./getShouldQueryForGroup");
function getAggregationQueryForGroup(groups) {
    const aggsQuery = {};
    groups.forEach((group) => {
        const groupId = group.id || group._id;
        aggsQuery[groupId] = {
            filter: getShouldQueryForGroup_1.getShouldQueryForGroup(group),
            aggs: {
                totalMembers: {
                    sum: {
                        script: '1'
                    }
                },
                staticMembers: {
                    terms: {
                        field: 'groupIds',
                        size: 10000
                    }
                },
                dynamicMembers: {
                    terms: {
                        field: 'dynamicGroupIds',
                        size: 10000
                    }
                }
            }
        };
    });
    return aggsQuery;
}
exports.getAggregationQueryForGroup = getAggregationQueryForGroup;
//# sourceMappingURL=getAggregationQueryForGroup.js.map